import type { ReactNode } from 'react';
import { useStore } from '../../store/store';

/** Minimal branded shell for full-page system states (no stepper). */
function SystemLayout({ children }: { children: ReactNode }) {
  return (
    <div className="app">
      <header className="hdr">
        <div className="hdr__brand">
          <span className="hdr__wordmark">REWIND</span>
          <span className="hdr__eyebrow">Print Order</span>
        </div>
        <div className="hdr__right" />
      </header>
      <main className="app__main">
        <div className="center-screen">{children}</div>
      </main>
    </div>
  );
}

export function LoadingScreen() {
  return (
    <SystemLayout>
      <div className="spinner" aria-label="Loading" role="status" />
      <p className="center-screen__body">Loading your order…</p>
    </SystemLayout>
  );
}

/** Shown when a resumed/stored project 404s (expired or unknown). */
export function RestartScreen() {
  const restart = useStore((s) => s.restart);
  return (
    <SystemLayout>
      <h1 className="center-screen__title">This order session has expired</h1>
      <p className="center-screen__body">
        We couldn&rsquo;t find your in-progress order. It may have expired. Start a fresh one to
        keep ordering; your photos will need re-uploading.
      </p>
      <button type="button" className="btn btn--primary" onClick={() => void restart()}>
        Start a new order
      </button>
    </SystemLayout>
  );
}

export function ErrorScreen() {
  const restart = useStore((s) => s.restart);
  return (
    <SystemLayout>
      <h1 className="center-screen__title">Something went wrong</h1>
      <p className="center-screen__body">
        We couldn&rsquo;t start your order. Check your connection and try again.
      </p>
      <button type="button" className="btn btn--primary" onClick={() => void restart()}>
        Try again
      </button>
    </SystemLayout>
  );
}
